var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { getAppRoot } from "@/onload";
import { fetcher } from "./schema";
export const invocationsFetcher = fetcher.path("/api/invocations").method("get").create();
export const stepJobsSummaryFetcher = fetcher
    .path("/api/invocations/{invocation_id}/step_jobs_summary")
    .method("get")
    .create();
export function invocationForJob(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(`${getAppRoot()}api/invocations?job_id=${params.jobId}`);
        if (data.length > 0) {
            return data[0];
        }
        else {
            return null;
        }
    });
}
// TODO: Replace these provisional functions with fetchers after https://github.com/galaxyproject/galaxy/pull/16707 is merged
export function fetchInvocationDetails(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(`${getAppRoot()}api/invocations/${params.id}`);
        return {
            data,
        };
    });
}
export function fetchInvocationJobsSummary(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(`${getAppRoot()}api/invocations/${params.id}/jobs_summary`);
        return {
            data,
        };
    });
}
export function fetchInvocationStep(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(`${getAppRoot()}api/invocations/steps/${params.id}`);
        return {
            data,
        };
    });
}
